
<div class="grid">
  <div class="col-12 md:col-4">
    <div class="form-group">
      <label for="start_date">From Date:</label>
      <p-calendar
        id="start_date"
        [style]="{ width: '100%' }"
        [(ngModel)]="start_date"
        dateFormat="dd-mm-yy"
        [showIcon]="true"
        [maxDate]="end_date"
      ></p-calendar>
      <div *ngIf="startDateError">
        <small class="text-danger">Invalid date</small>
      </div>
    </div>
  </div>
  <div class="col-12 md:col-4">
    <div class="form-group">
      <label for="end_date">To Date:</label>
      <p-calendar
        id="end_date"
        [style]="{ width: '100%' }"
        [(ngModel)]="end_date"
        dateFormat="dd-mm-yy"
        [showIcon]="true"
        [minDate]="start_date"
      ></p-calendar>
      <div *ngIf="endDateError">
        <small class="text-danger">Invalid date</small>
      </div>
    </div>
  </div>

  <div class="col-12" *ngIf="toggled">
    <div class="form-group">
      <label for="file_name">File Name:</label>
      <div class="p-inputgroup">
        <input type="text" [(ngModel)]="file_name"  pInputText [pKeyFilter]="'alpha'"     pAutoFocus
        [autofocus]="true"  placeholder="File Name" />
        <span class="p-inputgroup-addon">.csv</span>
    </div>
    </div>
  </div>
  <div class="col-12 " *ngIf="toggled">
    <h6>Include Columns</h6>
    <p>Select which columns to include in the report.</p>
    <form [formGroup]="form" class="grid">
      <div class="sm:col-3 md:col-4" *ngFor="let item of fields;">
        <div >
          <input type="checkbox" [formControlName]="item.value" id="{{item.value}}">
          <label for="{{item.value}}" class="mx-2">{{item.name}}</label>
        </div>

      </div>

    </form>
  </div>
  <div class="col-12 text-center my-3">
    <p-button label="Export Data" (click)="onSubmit()"></p-button>
  </div>
</div>

